import React from 'react';
import { useFetch } from 'bv-hooks';
import PropTypes from 'prop-types';
import fetchEnabledLocales from 'Seo/api/fetch_enabled_locales';
import AlternateLanguagesView from './alternate_languages_view';
import fetchHreflangOmissions from '../../api/fetch_hreflang_omissions';

const AlternateLanguagesContainer = ({ currentPathWithoutLocale }) => {
  const [data, loading] = useFetch(fetchEnabledLocales);
  const [hreflangOmissions, loadingHrefLangOmissions] = useFetch(() => (
    fetchHreflangOmissions(currentPathWithoutLocale)), [currentPathWithoutLocale],
  );

  if (loading || loadingHrefLangOmissions) return null;

  return (
    <AlternateLanguagesView
      languages={data}
      hreflangOmissions={hreflangOmissions}
      currentPathWithoutLocale={currentPathWithoutLocale}
    />
  );
};

AlternateLanguagesContainer.propTypes = {
  currentPathWithoutLocale: PropTypes.string.isRequired,
};

export default AlternateLanguagesContainer;
